import { render, staticRenderFns } from "./replenishment-detail.vue?vue&type=template&id=08804a6f&scoped=true&"
import script from "./replenishment-detail.vue?vue&type=script&lang=js&"
export * from "./replenishment-detail.vue?vue&type=script&lang=js&"
import style0 from "./replenishment-detail.vue?vue&type=style&index=0&id=08804a6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08804a6f",
  null
  
)

export default component.exports